import React from 'react';
import { Divider, Row, Col, List, Card, Space, Layout } from 'antd';
import AggregateToolbar from './components/AggregateToolbar';
import AggregateTickerTable from './components/AggregateTickerTable';
import {useEnsureTickersLoaded} from "../../../hooks/useEnsureTickersLoaded";
import TickerChip from "../../../Components/TickerChip";
import GraphicSider from "../../../Components/GraphicSider";

const { Content, Sider } = Layout;


export const formatDescriptionDetails = (consolidatedList, etfs) => {

    let nodes = [];
    const etfDetails = Object.values(etfs);
    etfDetails.forEach((etf, index) => {
        nodes.push(
            <TickerChip
                ticker={etf}
                additionalItems={[<span style={{fontWeight: '600', color: 'var(--color-primary)'}}>
                {etf.holdings.length}</span>]}
            />
        )
    });
    return nodes;
};

const AggregateView = ({ detailedRows, onSubmit, blacklists, screens, consolidatedList, etfs, config, updateConfig }) => {
    const etfSymbols = Object.keys(etfs);
    const { tickers, loading } = useEnsureTickersLoaded(etfSymbols);
    if (loading) {
        return <div>Loading...</div>;
    }
    let etfsCopy = {};
    if (tickers) {
        tickers.forEach(x=>{
            etfsCopy[x.symbol] = {...x, ...etfs[x.symbol]}
        });
    }
    const descriptionItems = formatDescriptionDetails(consolidatedList, etfsCopy);

    console.log('tickers', tickers, descriptionItems)
    return (
        <Layout>
            <Layout.Sider
                width={300}
                style={{
                    background: "#FFF",
                    border: '1px solid #ededed',
                    padding: '40px 30px'
                }}
            >
                <AggregateToolbar onSubmit={onSubmit} blacklists={blacklists} screens={screens} config={config} updateConfig={updateConfig} />
            </Layout.Sider>
            <Content>
                <Card className="px-6" bordered={false}>
                    <Space wrap>
                    {descriptionItems.map((item, index) => (
                        <div className={'p-3'}>
                            {item}
                        </div>
                    ))}
                    </Space>
                    <AggregateTickerTable detailedRows={detailedRows} />
                </Card>
            </Content>
        </Layout>
    );
};

export default AggregateView;
